<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="6">
        <b-form onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              v-model="form.searchKey"
              @keyup.enter="query"
              type="search"
              :placeholder="'Search here...'"
              size="sm"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l("INDEX.advanced_search") || "高级搜索" }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="fromLoad('add')"
              v-if="allow('A')"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l("tips_add") || "新增素材" }}
            </b-button>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="fromLoad('batchAdd')"
              v-if="allow('A')"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l("tips_batchAdd") || "批量新增" }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>

    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="700px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" size="medium">
        <el-row :gutter="20">
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item :label="$l('form_label_name_cn') || '素材中文'">
              <el-input
                v-model.trim="form.deName"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item :label="$l('form_label_name_en') || '素材英文'">
              <el-input
                v-model.trim="form.deNameEn"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item
              :label="$l('INDEX.check_label_select_category') || '字段类型'"
            >
              <dict-select
                v-model="form.deCategoryCode"
                filterable
                clearable
                url="/digitalCenter/common/dict/elementCategorySelect"
                size="medium"
                :placeholder="
                  $l('INDEX.check_label_select_category') || '请选择分类'
                "
                style="width: 100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item :label="$l('search_label_status') || '状态'">
              <br />
              <el-checkbox-group v-model="form.deStatusList">
                <el-checkbox label="Y">{{
                  $l("form_radio_valid") || "有效"
                }}</el-checkbox>
                <el-checkbox label="N">{{
                  $l("form_radio_invalid") || "无效"
                }}</el-checkbox>
                <el-checkbox label="S">{{
                  $l("form_radio_draft") || "草稿"
                }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="margin-top: 10px">
          <el-form-item
            :label="$l('INDEX.table_label_modification_date') || '修改时间'"
          >
            <el-col :span="24">
              <el-col :sm="{ span: 24 }" :md="{ span: 11 }" :lg="{ span: 11 }">
                <el-date-picker
                  v-model="form.modifyDateStart"
                  type="date"
                  size="small"
                  value-format="yyyy-MM-dd"
                  :placeholder="
                    $l('INDEX.Please select a start time') || '请选择开始时间'
                  "
                  style="width: 100%"
                  :picker-options="modifyDateStart"
                >
                </el-date-picker>
              </el-col>
              <el-col class="line" :span="2" style="text-align:center;">-</el-col>
              <el-col :sm="{ span: 24 }" :md="{ span: 11 }" :lg="{ span: 11 }">
                <el-date-picker
                  v-model="form.modifyDateEnd"
                  type="date"
                  size="small"
                  value-format="yyyy-MM-dd"
                  :placeholder="
                    $l('INDEX.Please select an end time') || '请选择结束时间'
                  "
                  style="width: 100%"
                  :picker-options="modifyDateEnd"
                >
                </el-date-picker>
              </el-col>
            </el-col>
          </el-form-item>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l("INDEX.btn_cancel_query") || "取消查询"
        }}</el-button>
        <el-button size="small" type="warning" @click="reset">{{
          $l("INDEX.btn_reset_filter ") || "重置条件"
        }}</el-button>
        <el-button size="small" type="primary" @click="advquery">{{
          $l("INDEX.btn_data_retrieval") || "数据检索"
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const initForm = {
  searchKey: "",
  deStatusList: ["Y", "S"],
  deCategoryCode: "",
};

export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: {
        ...initForm,
      },
    };
  },
  methods: {
    fromLoad(val) {
      if ("add" === val) {
        this.$emit("add");
      } else {
        this.$emit("batchAdd");
      }
    },
    onReset() {
      this.form = {
        ...initForm,
      };
      this.$emit("reset");
      this.query();
    },
    query() {
      this.$emit("submit", this.form);
    },
    // 高级查询
    advquery() {
      this.form.searchKey = "";
      this.query();
      this.closeAdvqueryDialog();
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm };
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true;
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false;
    },
  },
  created() {
    this.onReset();
  },
  activated() {
    this.query();
  },
};
</script>
